(() => {
  const initialized = new WeakSet();
  function init(root = document) {
    root.querySelectorAll(".jp-menu").forEach(menu => { menu.open = matchMedia("(min-width: 1100px)").matches; });
    root.querySelectorAll('[data-jp-rail], [data-jp-slider]').forEach(el => {
      if (initialized.has(el)) return;
      initialized.add(el);
      const track = el.querySelector('[data-jp-track]');
      const prev = el.querySelector('[data-jp-prev]');
      const next = el.querySelector('[data-jp-next]');
      const slider = el.hasAttribute('data-jp-slider');
      const pause = el.querySelector('[data-jp-pause]');
      let paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      let hovering = false;
      let focused = false;
      const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      function step(direction) {
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        if (slider && direction > 0 && atEnd) track.scrollTo({left: 0, behavior});
        else if (slider && direction < 0 && track.scrollLeft < 4) track.scrollTo({left: track.scrollWidth, behavior});
        else track.scrollBy({left: direction * (slider ? track.clientWidth : track.firstElementChild.getBoundingClientRect().width + 16), behavior});
      }
      prev.addEventListener('click', () => step(-1));
      next.addEventListener('click', () => step(1));
      function update() {
        if (!slider) {
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        }
      }
      track.addEventListener('scroll', update, {passive:true});
      new ResizeObserver(update).observe(track);
      update();
      if (slider) {
        const updatePause = () => { pause.textContent = paused ? '▶' : 'Ⅱ'; pause.setAttribute('aria-label', paused ? 'Reproduzir slideshow' : 'Pausar slideshow'); };
        pause.addEventListener('click', () => { paused = !paused; updatePause(); });
        updatePause();
        el.addEventListener('mouseenter', () => hovering = true);
        el.addEventListener('mouseleave', () => hovering = false);
        el.addEventListener('focusin', () => focused = true);
        el.addEventListener('focusout', e => focused = el.contains(e.relatedTarget));
        const timer = setInterval(() => {
          if (!el.isConnected) return clearInterval(timer);
          if (!paused && !hovering && !focused && !document.hidden && track.children.length > 1) step(1);
        }, 5500);
      }
    });
  }
  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();

/* Pause decorative background video outside the viewport. */
(() => {
 const seen = new WeakSet();
 const motion = matchMedia('(prefers-reduced-motion: reduce)');
 function setup(root = document) {
  root.querySelectorAll('[data-jp-background-video]').forEach(video => {
   if (seen.has(video)) return;
   seen.add(video);
   let visible = false;
   function sync() {
    if (visible && !document.hidden) {
     video.muted = true;
     const attempt = video.play();
     if (attempt) attempt.catch(() => {});
    } else video.pause();
   }
   video.addEventListener('loadeddata', sync);
   video.addEventListener('canplay', sync);
   const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, {threshold:0.01});
   observer.observe(video.closest('.jp-heading-video') || video);
   document.addEventListener('visibilitychange', sync);
   motion.addEventListener('change', sync);
   document.addEventListener('shopify:section:unload', event => {
    if (event.target.contains(video)) { observer.disconnect(); video.pause(); document.removeEventListener('visibilitychange', sync); motion.removeEventListener('change', sync); }
   });
  });
 }
 setup();
 document.addEventListener('shopify:section:load', event => setup(event.target));
})();

/* JP colors, photo cycling and native cart trigger. */
(() => {
 const initialized = new WeakSet();
 function cards(root = document) {
  root.querySelectorAll('[data-jp-card]').forEach(card => {
   if (initialized.has(card)) return;
   initialized.add(card);
   const img = card.querySelector('.jp-product-image img');
   const colors = [...card.querySelectorAll('[data-jp-color]')];
   let interaction = false, visible = false, index = 0;
   function image(src, alt) { if (!img || !src) return; img.removeAttribute('srcset'); img.src = src; if (alt) img.alt = alt; }
   colors.forEach(button => button.addEventListener('click', () => {
    interaction = true;
    colors.forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    image(button.dataset.image);
    if (button.dataset.url) card.querySelectorAll('a').forEach(a => a.href = button.dataset.url);
   }));
   const template = card.querySelector('[data-jp-card-images]');
   if (!template || colors.length || !window.jpCardCycle || !img) return;
   const images = [...template.content.querySelectorAll('[data-src]')];
   const observer = new IntersectionObserver(entries => visible = entries[0].isIntersecting);
   observer.observe(card);
   card.addEventListener('mouseenter', () => interaction = true);
   card.addEventListener('mouseleave', () => interaction = false);
   card.addEventListener('focusin', () => interaction = true);
   card.addEventListener('focusout', e => interaction = card.contains(e.relatedTarget));
   const timer = setInterval(() => {
    if (!card.isConnected) { clearInterval(timer); observer.disconnect(); return; }
    if (visible && !interaction && !document.hidden && images.length > 1) { index = (index + 1) % images.length; image(images[index].dataset.src, images[index].dataset.alt); }
   }, 4000);
  });
 }
 cards();
 const mutations = new MutationObserver(() => cards());
 mutations.observe(document.getElementById('MainContent') || document.body, {childList:true,subtree:true});
 document.addEventListener('click', async event => {
  const trigger = event.target.closest('[data-jp-cart-trigger]');
  if (!trigger || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  event.preventDefault();
  await customElements.whenDefined('theme-drawer');
  drawer.open();
 });
 document.addEventListener('shopify:section:load', e => cards(e.target));
 document.addEventListener('shopify:cart:lines-update', () => {
  fetch((window.Shopify?.routes?.root || '/') + 'cart.js').then(r => r.json()).then(cart => document.querySelectorAll('[data-jp-cart-count]').forEach(el => el.textContent = cart.item_count)).catch(() => {});
 });
})();
